module.exports = __webpack_public_path__ + "media/images/logos/zoom_rounded-ed9c3fd32a57737527028674e87fdf86.svg";